import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import SelectCountry from './Country/SelectCountry';
import NotFound from './NotFound';
import Home from './USA/Component/Home';
import AboutPage from './USA/AboutPage';
import Contact from './USA/Contact';
import OurGallery from './USA/OurGallery';
import AboutDidiJi from './USA/AboutDidiJi';
import VideoLectures from './USA/VideoLectures';
import WordsOfWisdom from './USA/WordsOfWisdom';
import TempleActivities from './USA/TempleActivities';
import ActivityCalendar from './USA/ActivityCalendar';
import VolunteerRegistration from './USA/VolunteerRegistration';
import Directions from './USA/Directions';
import EventRentals from './USA/EventRentals';
import OurEvent from './USA/OurEvent';
import MyGallery from './USA/MyGallery';
import Blogs from './USA/Blogs';
import BlogDetails from './USA/BlogDetails';
import Camp from './USA/Camp/SummerCamp';
import DevotionalRetreat from './USA/Camp/DevotionalRetreat';
import Volleyball from './USA/Camp/Volleyball';
import MilwaukeeSummerCamp from './USA/Camp/MilwaukeeSummerCamp';
import SpringBreakKidsCamp from './USA/Camp/Springbreakkidscamp';
import GlobalSeva from './USA/Camp/GlobalSeva';
import Winter from './USA/Camp/WinterCamp';
import DivaliLecture from './USA/Camp/DivaliLecture';

import SpringCamp from './USA/Camp/SpringCamp';

import InaugurationEvents from "./USA/Camp/InaugurationEvents";
import CampJanmashtami from "./USA/Camp/Janmashtami";
import JanmashtamiParking from "./USA/Camp/JanmashtamiParking";
import GaneshChaturthi from "./USA/Camp/GaneshChaturthi";
import Radhashtami from "./USA/Camp/Radhashtami";
import FallFestival from "./USA/Camp/FallFestival";
import NavratriGarba from "./USA/Camp/NavratriGarba";
import RavanDahan from "./USA/Camp/RavanDahan";
import NavadhaBhakti from "./USA/Camp/NavadhaBhakti";
import SharadPoornima from "./USA/Camp/SharadPoornima";

import ClevelandRetreat from './USA/Camp/ClevelandOhioRetreat';
import FamilyOvernightCamping from './USA/Camp/Overnightcamp';
import YugalKunjexpansion from "./USA/YugalKunjexpansion";

import Anniversary from "./USA/Camp/10th Anniversary";
import Anniversary11th from "./USA/Camp/Anniversary11th";
import Thanksgiving from "./USA/Camp/Thanksgiving";
import FoodDonation from './USA/FoodDonation';

import WinterRetreat from './USA/Camp/WinterRetreat';
import MembershipRegister from './membership/pages/MembershipRegister';
import MembershipReports from './membership/pages/MembershipReports';
import DepartmentsPage from './USA/Component/departments/DepartmentsPage';
import DepartmentDetailPage from './USA/Component/departments/DepartmentDetailPage';
import GmailWordsOfWisdom from './USA/GmailWordsOfWisdom';
import WordsOfWisdomAdmin from './USA/WordsOfWisdomAdmin';
import PrivacyPolicy from './USA/PrivacyPolicy';
import TermsOfService from './USA/TermsOfService';

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path='*' element={<NotFound />} />
          <Route path='/' element={<SelectCountry />} />
          <Route path='/USA/Home' element={<Home />} />
          <Route path='/USA/about' element={<AboutPage />} />
          <Route path='/USA/ourGallery' element={<OurGallery />} />
          <Route path='/USA/gallery' element={<OurGallery />} />
          <Route path='/USA/aboutDidiJi' element={<AboutDidiJi />} />
          <Route path='/USA/contact' element={<Contact />} />
          <Route path='/USA/videoLectures' element={<VideoLectures />} />
          <Route path='/USA/wordsofwisdom' element={<WordsOfWisdom />} />
          <Route path='/USA/gmail-words-of-wisdom' element={<GmailWordsOfWisdom />} />
          <Route path='/USA/words-of-wisdom-admin' element={<WordsOfWisdomAdmin />} />
          <Route path='/USA/gmail words of wisdom' element={<GmailWordsOfWisdom />} />
          <Route path='/USA/templeactivities' element={<TempleActivities />} />
          <Route path='/USA/activitycalendar' element={<ActivityCalendar />} />
          <Route path='/USA/VolunteerRegistration' element={<VolunteerRegistration />} />
          <Route path='/USA/directions' element={<Directions />} />
          <Route path='/USA/eventrentals' element={<EventRentals />} />
          <Route path='/USA/upcomingevents' element={<OurEvent />} />
          <Route path='/USA/Blogs' element={<Blogs />} />
          <Route path='/USA/BlogDetails' element={<BlogDetails />} />
          <Route path='/USA/Camp/SummerCamp' element={<Camp />} />
          <Route path='/USA/Camp/DevotionalRetreat' element={<DevotionalRetreat />} />
          <Route path='/USA/Camp/Winter' element={<Winter />} />
          <Route path='/USA/Camp/MilwaukeeSummerCamp' element={<MilwaukeeSummerCamp />} />
          <Route path='/USA/Camp/Springbreakkidscamp' element={<SpringBreakKidsCamp />} />
          <Route path='/USA/Camp/GlobalSeva' element={<GlobalSeva />} />
          <Route path='/USA/Camp/Volleyball' element={<Volleyball />} />
          <Route path='/USA/Camp/Cleveland-Retreat' element={<ClevelandRetreat />} />
          <Route path='/USA/Camp/FamilyOvernightCamping' element={<FamilyOvernightCamping />} />
          <Route path='/USA/YugalKunjexpansion' element={<YugalKunjexpansion />} />
          <Route path='/USA/InaugurationEvents' element={<InaugurationEvents />} />
          <Route path='/USA/Anniversary' element={<Anniversary />} />
          <Route path='/USA/Anniversary11th' element={<Anniversary11th />} />
          <Route path='/USA/Camap/Thanksgiving' element={<Thanksgiving />} />
          <Route path='/USA/Camp/DivaliLecture' element={<DivaliLecture />} />
          <Route path='/USA/Janmashtami' element={<CampJanmashtami />} />
          <Route path='/USA/JanmashtamiParking' element={<JanmashtamiParking />} />
          <Route path='/USA/GaneshChaturthi' element={<GaneshChaturthi />} />
          <Route path='/USA/Radhashtami' element={<Radhashtami />} />
          <Route path='/USA/FallFestival' element={<FallFestival />} />
          <Route path='/USA/NavratriGarba' element={<NavratriGarba />} />
          <Route path='/USA/RavanDahan' element={<RavanDahan />} />
          <Route path='/USA/NavadhaBhakti' element={<NavadhaBhakti />} />
          <Route path='/USA/SharadPoornima' element={<SharadPoornima />} />
          <Route path='/USA/FoodDonation' element={<FoodDonation />} />
          <Route path='/USA/WinterRetreat' element={<WinterRetreat />}></Route>
          <Route path='/USA/membership/register' element={<MembershipRegister />} />
          <Route path='/USA/membership/reports' element={<MembershipReports />} />
          <Route path='/USA/departments' element={<DepartmentsPage />} />
          <Route path='/USA/departments/:slug' element={<DepartmentDetailPage />} />
          <Route path='/USA/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/USA/terms-of-service' element={<TermsOfService />} />
           <Route path='/USA/Camp/SpringCamp' element={<SpringCamp />} />

          <Route path='/MyGallery' element={<MyGallery />} />
          <Route path='/CAD/*' element={<Navigate to='/' replace />} />
          <Route path='/Canada/*' element={<Navigate to='/' replace />} />
          <Route path='/Summer-camp-2024' element={<Navigate to='/' replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
